import React from "react";
import Container from "@mui/material/Container";
import { useNavigate } from "react-router-dom";

export default function ContactUsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Container
        maxWidth="md"
        sx={{
          pt: 3,
          pb: 4,
        }}
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-orange-600 hover:text-orange-700 font-medium"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 16L6 10L12 4"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <h1 className="text-2xl font-bold text-gray-900">Contact Us</h1>
          <div className="w-20" />
        </div>

        {/* Intro Text */}
        <div className="mb-6">
          <p className="text-gray-600 text-center">
            Have questions or feedback? We'd love to hear from you. Get in touch with our support team.
          </p>
        </div>

        {/* Contact Information Cards */}
        <div className="space-y-4 mb-8">
          {/* Email Card */}
          <div className="bg-white rounded-lg p-5 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 6L12 11L20 6M4 6H20C21.1046 6 22 6.89543 22 8V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V8C2 6.89543 2.89543 6 4 6Z"
                    stroke="#EF6C00"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-1">Email</h3>
                <a
                  href="mailto:support@koinapp.co"
                  className="text-orange-600 hover:text-orange-700 font-medium text-sm"
                >
                  support@koinapp.co
                </a>
                <p className="text-gray-500 text-xs mt-1">Response within 24 hours</p>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ Link */}
        <div className="mt-8 p-4 bg-gradient-to-r from-orange-50 to-amber-50 rounded-lg border border-orange-200 text-center">
          <p className="text-gray-700 text-sm mb-3">
            Looking for quick answers?
          </p>
          <a
            href="/help"
            className="inline-block px-6 py-2 bg-orange-600 text-white rounded-lg font-medium hover:bg-orange-700 transition-colors"
          >
            Visit Help & FAQs
          </a>
        </div>
      </Container>
    </div>
  );
}
